export const environment = {
  apiUrl: 'https://dev-resource.gloster.hu',
  baseUrl: 'https://dev-resource.gloster.hu/api',
  googleAuthLink: 'https://dev-resource.gloster.hu/api/oauth2/authorize/google',
  microsoftAuthLink: 'https://dev-resource.gloster.hu/api/oauth2/authorize/azure-dev',
  production: false,
  storagePrefix: 'resource_app_',
  refreshTime: 30000,
};